import { BuildClass, Do, timer } from '../../universal';
import { React, _ } from '../lib';
import { openNavLinkMaybe } from './component-frame';
import { IRIS } from './component-iris';
import { CJSX, FormButton, FormButtonSet, LoadingSpinnerLarge, Textbox } from './ui5';
export const openMFALoginForm = () => ({
    cappedWidth: true,
    theme: 'green',
    content: () => ({
        tag: MFALoginForm,
        redirect: Do(() => {
            const p = new URLSearchParams(window.location.search);
            return p.get('rd');
        }),
    }),
});
export const MFALoginForm = (props) => {
    const [token, setToken] = React.useState('');
    const [error, setError] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(false);
    const [successful, setSuccessful] = React.useState(null);
    const onSave = (this_token) => {
        setError('');
        setIsLoading(true);
        IRIS.Send({
            data: {
                progID: 0,
                funcID: 33,
                token: this_token,
            },
            no: data => {
                setIsLoading(false);
                setError(data.message);
            },
            yes: () => {
                onComplete();
            },
        });
    };
    const onComplete = () => {
        if (props.flyout == null) {
            if (props.redirect != null) {
                openNavLinkMaybe(props.redirect, true);
            }
            return;
        }
        props.onComplete?.();
        setSuccessful(true);
        props.flyout?.Close();
    };
    React.useEffect(() => {
        if (props.flyout == null && window.rootData.Page['isElevated']) {
            setSuccessful(true);
            timer(() => {
                onComplete();
            });
        }
        else {
            setSuccessful(false);
        }
        return () => {
            if (!successful) {
                ;
                (props.onCloseFailed ?? _.noop)();
            }
        };
    }, []);
    if (successful || successful == null) {
        return React.createElement(LoadingSpinnerLarge, null);
    }
    const isFlyout = props.flyout != null;
    return (React.createElement("form", { className: "tailwind-wrapper mfa-login-page", onSubmit: e => {
            e.preventDefault();
            onSave(token);
        } },
        React.createElement(CJSX, { cond: props.flyout == null },
            React.createElement("h1", { className: "text-5xl font-condensed font-extralight" }, "MFA Elevation Required")),
        React.createElement("div", { className: BuildClass({
                'font-condensed text-[#333] my-[5px] mx-0': isFlyout,
            }) }, "You are trying to access a TriOnline feature that requires the use of multi-factor authentication. Please enter the 6-digit MFA token from your device below to elevate your session. Note that if you are inactive for 15 minutes you will need to re-enter the token."),
        React.createElement("div", { className: BuildClass({
                'text-center max-w-[480px]': true,
                'py-[10px]': isFlyout,
                'rounded-lg py-8 my-8 mx-auto': !isFlyout,
                'shadow-[0_1.3px_5.1px_rgba(0,0,0,0.096),0_4.2px_17.2px_rgba(0,0,0,0.116),0_19px_77px_rgba(0,0,0,0.23)]': !isFlyout,
            }) },
            React.createElement("div", { className: "mb-2" },
                React.createElement("img", { className: "inline w-12 align-middle", src: "/static/img/svg/login-mfa.svg" }),
                React.createElement(Textbox, { value: token, onUpdate: v => {
                        setToken(v);
                        if (v.length == 6) {
                            onSave(v);
                        }
                    }, className: BuildClass([
                        'w-[230px] h-12 my-0 mx-[10px]',
                        'text-center align-middle',
                        'tracking-[10px] font-condensed !text-4xl',
                        'placeholder:tracking-normal placeholder:text-[28px]',
                    ]), autoFocus: true, maxLength: 6, placeholder: "MFA Token" })),
            React.createElement("div", { className: "mb-2" },
                React.createElement("a", { className: "text-[#03f] hover:text[#f30]", target: "_blank", href: "https://trionline.com.au/kb/690/" }, "What is this?")),
            React.createElement(FormButtonSet, { loading: isLoading, msg: error, good: successful },
                React.createElement(FormButton, { lbl: "Authorise", onClick: _.noop, type: "submit", classNameSpan: BuildClass({
                        'text-2xl px-5 py-2': !isFlyout,
                        'text-[#333] font-condensed': true,
                    }) })),
            React.createElement(CJSX, { cond: !window.rootData.Page['hasRegistered'] },
                React.createElement("a", { className: BuildClass({
                        'register-mfa': true,
                        'text-[#77f] font-condensed': true,
                        'hover:text-[#00f]': true,
                    }), onClick: e => {
                        e.preventDefault();
                        if (window.AccountPage?.openMFARegistration) {
                            window.AccountPage.openMFARegistration();
                            return;
                        }
                        openNavLinkMaybe('/acct/');
                    } }, "Don't have an MFA registration?")))));
};
//# sourceMappingURL=component-mfa-login.js.map